import { BrowserRouter, Route, Routes } from "react-router-dom";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Home from "./pages/Home";
import Mypage from "./pages/Mypage";
import Quiz from "./pages/Quiz";
import QuizMistakes from "./pages/QuizMistakes";
import reportWebVitals from "./reportWebVitals";
import { SubscribeModalProvider } from "./providers/SubscribeModalProvider";
import { UserRegistrationProvider } from "./providers/UserRegistrationProvider";
import RegistrationModal from "./components/registration/RegistrationModal";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// クイズはLIFFに依存しないので、LIFFの初期化を待たずに即描画する。
// LINEユーザー前提のページ(Home/Mypageなど)は各コンポーネント側で必要になったときに
// liffClient.ensureLiffInit() を呼ぶ。
root.render(
  <React.StrictMode>
    <SubscribeModalProvider>
      <UserRegistrationProvider>
        <RegistrationModal />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/mypage" element={<Mypage />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/quiz/mistakes" element={<QuizMistakes />} />
          </Routes>
        </BrowserRouter>
      </UserRegistrationProvider>
    </SubscribeModalProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
